import { sliceName } from "./initialState";

export const selectPromotionRules = (state) => state[sliceName].rules;
export const selectIsPromotionRulesLoading = (state) => selectPromotionRules(state).isLoading;
export const selectShowPromotionRules = (state) => selectPromotionRules(state).showRules;
export const selectCurrentPromotionRules = (state) => selectPromotionRules(state).data;

export const getPromotionBets = state => state[sliceName].promotionBets;
export const selectUsePromotion = (state) => state[sliceName].usePromotion;
